// import React from 'react';
import ReactDOM from "react-dom/client";
// import App from './App';
import reportWebVitals from "./reportWebVitals";
// import { Provider } from 'react-redux';
import { PersistGate } from "redux-persist/integration/react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { Provider } from "react-redux";
import App from "./App";
import { persistor, store } from "./store";
import "bootstrap/dist/css/bootstrap.min.css";
import { configure } from "mobx";

configure({ isolateGlobalState: true });

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <I18nextProvider i18n={i18n}>
        <BrowserRouter>
        {/* <Routes>
        <Route path="/:slug" element={<App />} />
        </Routes> */}
        <App />
        </BrowserRouter>
      </I18nextProvider>
    </PersistGate>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
